// import axios from "../../axios/axios-nasa";
import axios from "axios";
import * as actionTypes from "./actionTypes";
import * as moment from "moment";

export const fetchPictureOfTheDay = () => {
  return dispatch => {
    dispatch(fetchPictureOfTheDayStart());
    let picturesOfTheDay = [];
    var promises = [];

    for (let i = 0; i < 45; i++) {
      promises.push(
        axios.get(
          "https://api.nasa.gov/planetary/apod?api_key=zDhFu0FmRAhzzljc6LEBZIqOeGYyB56fcQOdWPRL",
          {
            params: {
              date: moment()
                .add(-i, "days")
                .format("YYYY-MM-DD")
            }
          }
        )
      );
    }

    axios
      .all(promises)
      .then(results => {
        results.forEach(response => {
          if (response) {
            if (response.data.media_type === "image") {
              picturesOfTheDay.push(response.data);
            }
          }
        });

        dispatch(fetchPictureOfTheDaySuccess(picturesOfTheDay));
      })
      .catch(err => {
        console.log(err);
      });
  };
};

export const fetchPictureOfTheDayStart = () => {
  return {
    type: actionTypes.FETCH_PICTURE_OF_THE_DAY_START
  };
};

export const fetchPictureOfTheDaySuccess = pictureOfTheDay => {
  return {
    type: actionTypes.FETCH_PICTURE_OF_THE_DAY_SUCCESS,
    pictureOfTheDay: pictureOfTheDay
  };
};

export const fetchSpaceStation = () => {
  return dispatch => {
    dispatch(fetchSpaceStationStart());
    axios
      .get("https://api.wheretheiss.at/v1/satellites/25544")
      .then(res => {
        if(res.data) {
          const spaceStationInformation = res.data;
          dispatch(fetchSpaceStationSuccess(spaceStationInformation));
        }
      })
      .catch(err => {
        alert(err);
      });
  };
};

export const fetchSpaceStationStart = () => {
  return {
    type: actionTypes.FETCH_SPACE_STATION_START
  };
};

export const fetchSpaceStationSuccess = spaceStationInformation => {
  return {
    type: actionTypes.FETCH_SPACE_STATION_SUCCESS,
    spaceStationInformation: spaceStationInformation
  };
};

// export function fetchPictureOfTheDay(userId) {
//   return {
//     types: [actionTypes.FETCH_PICTURE_OF_THE_DAY_START, actionTypes.FETCH_PICTURE_OF_THE_DAY_SUCCESS],
//     shouldCallAPI: true,
//     callAPI: () => {
//       var promises = [];
//       for (let i = 0; i < 30; i++) {
//         console.log(
//           moment()
//             .add(-i, "days")
//             .format("YYYY-MM-DD")
//         );
//         promises.push(
//           axios.get(
//             "https://api.nasa.gov/planetary/apod?api_key=zDhFu0FmRAhzzljc6LEBZIqOeGYyB56fcQOdWPRL",
//             {
//               params: {
//                 date: moment()
//                   .add(-i, "days")
//                   .format("YYYY-MM-DD")
//               }
//             }
//           )
//         );
//       }

//       axios
//         .all(promises)
//         // .then(results => {
//         //   results.forEach(response => {
//         //     if (response) {
//         //       console.log(response.data);
//         //       picturesOfTheDay.push(response.data);
//         //     }
//         //   });
//         //   console.log(picturesOfTheDay);
//         //   dispatch(fetchPictureOfTheDaySuccess(picturesOfTheDay));
//         // })
//         // .catch(err => {
//         //   alert(err);
//         // });
//     },
//     payload: {  }
//   }
// }

// function callAPIMiddleware({ dispatch, getState }) {
//   return next => action => {
//     const { types, callAPI, shouldCallAPI = () => true, payload = {} } = action;

//     if (!types) {
//       // Normal action: pass it on
//       return next(action);
//     }

//     if (
//       !Array.isArray(types) ||
//       types.length !== 3 ||
//       !types.every(type => typeof type === "string")
//     ) {
//       throw new Error("Expected an array of three string types.");
//     }

//     if (typeof callAPI !== "function") {
//       throw new Error("Expected callAPI to be a function.");
//     }

//     if (!shouldCallAPI(getState())) {
//       return;
//     }

//     const [requestType, successType, failureType] = types;

//     dispatch(
//       Object.assign({}, payload, {
//         type: requestType
//       })
//     );

//     return callAPI().then(
//       response =>{
//         
//         dispatch(
//           Object.assign({}, payload, {
//             response,
//             type: successType
//           })
//         )},
//       error =>
//         dispatch(
//           Object.assign({}, payload, {
//             error,
//             type: failureType
//           })
//         )
//     );
//   };
// }
